import { hexToRgb } from '@mui/material';
import { get } from '../lib/api';

export function getLayerProperties(id) {
  return get(`/map/properties/${id}`);
}

export async function getLayerChartColors(id) {
  const properties = await getLayerProperties(id);
  return mapLayerColors(properties.legend);
}

export function mapLayerColors(legend) {
  return Object.entries(legend).reduce((colors, [maxValue, { color, rgb }]) => {
    const rgbValue = rgb ? [...rgb, 255] : parseLegendColor(color);
    colors[maxValue] = rgbValue;
    return colors;
  }, {});
}

function parseLegendColor(color) {
  const rgbString = color.includes('#') ? hexToRgb(color) : color;
  const rgbValues = rgbString
    .match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/)
    ?.slice(1);
  return [...rgbValues.map((value) => parseInt(value, 10)), 255];
}
